import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import './OfferContent.scss';

function OfferContent({ dataItem }) {
  const {
    assets: { shortSummaryText },
    merchant: {
      name,
      id,
      rebate,
      logoUrls: {
        _120x60,
        _88x31,
      },
    },
  } = dataItem;

  const isMobileMQ = useSelector(selectIsMobileMQ);
  const logoImgSrc = isMobileMQ ? _120x60 : _88x31;

  return (
    <div className="mn_offerContent">
      <div className="mn_logoWrap">
        <img className="mn_logo" src={logoImgSrc} alt={name} />
      </div>
      <div className="mn_offerInfoWrap">
        <FavoriteIcon merchantId={id} merchantName={name} />
        <div
          className="mn_shortSummary"
          dangerouslySetInnerHTML={{ __html: shortSummaryText }}
        />
        <div className="mn_merchantRebateWrap" data-test="featured-offer-150x150-rebate">
          <MerchantRebateV2 {...rebate} hideRebatePrefix hideElevationCurrency />
        </div>
      </div>
    </div>
  );
}

export default OfferContent;
